module.exports = __webpack_public_path__ + "static/img/rank_homepage_avatar3.df7b288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank/rank_homepage_avatar3.png
// module id = 82wX
// module chunks = 0